export const primaryBlue = '#172982';
export const primaryGreen = '#438F36';
export const primary = '#2ecc71';
export const lighterBlue = '#7B7D86';
export const primaryOrange = '#ff7b2e';
export const oraColor = '#E96D6C';
export const tixColor = '#4D9BD3';
export const lightOraColor = '#EFAFAF';
